	
const urlParams = new URLSearchParams(window.location.search);
export const debug = urlParams.get('debug') != null;
